import React from 'react';
import { Text, Button } from '@cuemath/web-comps';
import { Separator } from '@cuemath/comps';

import ChipGroup from '../chips';
import CountrySelect from '../country-select';
import FunnelBarChart from '../charts/funnel-bar-chart';
import { SectionLabel, Card, ChartBox, ChipGroupsRow, ActionsField, UI } from '../../styled-comps';
import {
  YEAR_OPTIONS,
  MONTH_OPTIONS,
  GRAPH_METRIC_OPTIONS,
  REGION_OPTIONS,
  USER_TYPE_OPTIONS,
  EMPTY_MESSAGE,
} from '../../constants';

// The independent month-on-month graph card shared by Category and Non-Content:
// its own Year / Metric / Region / User-type chips + a stacked-bar chart of the
// top series. The owning tab computes `datasets` (via helpers.buildMonthlyTopSeries)
// and passes the section label + caption, which are the only per-tab differences.
const TopSeriesGraphCard = ({
  sectionLabel,
  caption,
  graphYear,
  onYearChange,
  graphMetric,
  onMetricChange,
  regions,
  onRegionsChange,
  countries,
  onCountriesChange,
  userTypes,
  onUserTypesChange,
  axisYear,
  hasUnapplied,
  onApply,
  onReset,
  datasets,
  hasRawData,
  loading,
  error,
}) => (
  <>
    <SectionLabel>{sectionLabel}</SectionLabel>
    <Card>
      <ChipGroupsRow>
        <ChipGroup label="Year" options={YEAR_OPTIONS} value={graphYear} onChange={onYearChange} />
        <ChipGroup
          label="Metric"
          options={GRAPH_METRIC_OPTIONS}
          value={graphMetric}
          onChange={onMetricChange}
        />
        <ChipGroup
          label="Region"
          options={REGION_OPTIONS}
          value={regions}
          onChange={onRegionsChange}
          multi
        />
        <ChipGroup
          label="User type"
          options={USER_TYPE_OPTIONS}
          value={userTypes}
          onChange={onUserTypesChange}
          multi
        />
      </ChipGroupsRow>
      {!!(regions && regions.length) && (
        <>
          <Separator height={10} transparent />
          <CountrySelect regions={regions} value={countries} onChange={onCountriesChange} />
        </>
      )}
      <Separator height={12} transparent />
      <ActionsField>
        <Button size="small" label={hasUnapplied ? 'Apply *' : 'Apply'} onClick={onApply} />
        <Button size="small" variant="tertiaryWithUnderline" label="Reset" onClick={onReset} />
      </ActionsField>
      <Separator height={14} transparent />
      {error ? (
        <Text variant="body2" color={UI.down}>{error}</Text>
      ) : (
        <ChartBox $height={320}>
          {loading && !hasRawData ? (
            <Text variant="body3" color={UI.muted}>Loading graph…</Text>
          ) : datasets.length ? (
            <FunnelBarChart
              labels={MONTH_OPTIONS.map(
                month => `${month.label}-${String(axisYear || graphYear).slice(2)}`,
              )}
              datasets={datasets}
              stacked
              showLegend
            />
          ) : (
            <Text variant="body3" color={UI.muted}>{EMPTY_MESSAGE}</Text>
          )}
        </ChartBox>
      )}
      <Separator height={6} transparent />
      <Text variant="caption" color={UI.muted}>{caption}</Text>
    </Card>
  </>
);

export default TopSeriesGraphCard;
